import { Hatch, SafeString } from "./classes/Hatch.js";

import { SampleEvent, Task } from "./global/interfaces";

import Utils from "./classes/Utils";

const https = window.location.protocol === "https:";
const SOCKET_URL = `ws${https ? "s" : ""}://${window.location.host}`;

function getTags(obj: SampleEvent) {
  let uniqueTags = {};
  obj.tasks.forEach((t: Task) => {
    if (t.tags) {
      t.tags.forEach((tag) => {
        if (tag.split(":").length === 2) {
          uniqueTags[tag.split(":")[1]] = tag.split(":")[0];
        } else {
          uniqueTags[tag] = "normal";
        }
      });
    }
  });

  return Object.entries(uniqueTags)
    .map(
      (i) => Hatch`
       <span class="${i[1]}">${i[0]}</span>
     `
    )
    .join("");
}

document.addEventListener("DOMContentLoaded", function () {
  let handlers = {
    init: () => {
      handlers.rowUpdater();
      if (document.querySelector("#export-csv")) {
        document.querySelector("#export-csv").addEventListener("click", handlers.downloadCsv);
      }
      document.querySelectorAll(".row [data-clipboard]").forEach((clipboard) => {
        clipboard.addEventListener("click", (e) => {
          e.preventDefault();
        });
      });
    },
    downloadCsv: (e: Event) => {
      e.preventDefault();
      document.querySelector("#search").setAttribute("action", "/export");
      document.querySelector<HTMLFormElement>("#search").submit();
    },
    updateRow: (obj: SampleEvent) => {
      let e = document.querySelector(`[data-sample-id="${obj.id}"]`);

      //Update rendered row
      if (!e) {
        return;
      }
      let severity = "normal";
      if (obj.score > 4) {
        severity = "warning";
      }
      if (obj.score > 7) {
        severity = "alert";
      }
      e.querySelector(".tags").innerHTML = getTags(obj);
      e.classList.remove("alert");
      e.classList.remove("warning");
      e.classList.remove("normal");
      e.classList.add(severity);
      e.querySelector<HTMLElement>(".score-holder").innerHTML = Hatch`
          <div class="score">
            <div class="ma-icon default">
              ${obj.score ? obj.score : new SafeString(Utils.stateToIcon(obj.state).icon)}
            </div>
          </div>
          ${Utils.stateToIcon(obj.state).label}
        `.s;
    },
    rowUpdater: () => {
      const socket = new WebSocket(SOCKET_URL + "/api/streams/sample");
      socket.addEventListener("message", function (event) {
        let obj = JSON.parse(event.data);
        handlers.updateRow(obj);
      });
    },
  };

  handlers.init();
});
